import { isApproval } from '../../../helpers/matchers'
import { buildMenuTooltip } from '../../../helpers/menuHelpers'
import { findFirstPhaseAfterCurrent } from '../../../helpers/phaseHelpers'
import { phaseActions } from '../../helpers'

/**
 * Can this phase be deleted?
 * A phase must be a future phase to be eligible for deletion.
 */
const canDeletePhase = (phase) =>
  !phase.is_active && !phase.is_complete && !phase.is_current && !phase.locked

/**
 * Can we retract approvals from this phase?
 * A phase must be an active Approvals Phase to be eligible for retraction.
 */
const canRetractApprovals = (phase) =>
  isApproval(phase.phase_type) && phase.is_active && !phase.is_complete

/**
 * Can this phase be moved up in the list?
 * Active/current phases cannot be moved, thus we need to prevent
 *    both the first/active phase and the one immediately after it.
 */
const canMoveUp = (phase) => {
  const phaseAfterCurrent = findFirstPhaseAfterCurrent(phase.workflow.phases)
  const isAfterCurrentPhase =
    phaseAfterCurrent && phaseAfterCurrent.id === phase.id

  return (
    !isAfterCurrentPhase &&
    !phase.isAfterActivePhase &&
    !phase.is_active &&
    !phase.is_current &&
    !phase.isFirst
  )
}

/**
 * Can this phase be moved down in the list?
 * A phase can be moved down if it is not active/current, and is not the last Phase in the current list.
 */
const canMoveDown = (phase) =>
  !phase.isLast && !phase.is_active && !phase.is_current

// Menu items specific to Approvals phases
const approvalsPhaseMenu = (phase) => [
  {
    title: 'Retract approvals',
    action: phaseActions.Retract,
    disabled: !canRetractApprovals(phase),
  },
]

// Menu items applicable to all phase types
function defaultMenu(phase) {
  const canDelete = canDeletePhase(phase)
  let deletePhaseTooltip = false
  if (!canDelete) {
    const tooltipText = phase.is_current
      ? 'Current phases cannot be deleted.'
      : 'This phase cannot be deleted because it is locked.'
    deletePhaseTooltip = buildMenuTooltip(tooltipText)
  }

  return [
    {
      title: 'Move phase up',
      action: phaseActions.MoveUp,
      disabled: !canMoveUp(phase),
    },
    {
      title: 'Move phase down',
      action: phaseActions.MoveDown,
      disabled: !canMoveDown(phase),
    },
    {
      title: 'Delete phase',
      action: phaseActions.Delete,
      disabled: !canDelete,
      tooltip: deletePhaseTooltip,
    },
  ]
}

export function buildMenu(phase) {
  const menuForPhaseType = isApproval(phase.phase_type)
    ? approvalsPhaseMenu(phase)
    : [] // currently no specific actions needed for Task Phases
  return [...menuForPhaseType, ...defaultMenu(phase)]
}

export default {
  buildMenu,
}
